import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { notification } from "antd";
import DeleteModal from "../../components/DeleteModal";
import CancelReceiptModal from "./CancelReceiptModal";
import axios from "axios";

export default function CancelBusReceipt() {
  const { fee_id,ref_no } = useParams();
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const token = getToken();
  const userId=decodeToken(token,'id');
  const [invoice] = useState(`RV-${ref_no}`);
  const [tranDate, setTranDate] = useState("");
  const [reason, setReason] = useState("");
  const [rows, setRows] = useState([]);
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateValues, setUpdateValues] = useState({
  table: 'student_bus_receipt',
  id: null,       // will set dynamically per row
  column: '',     // 'amount' or 'tran_date'
  value: '',      // the new value
  user_id: userId,
});

  useEffect(() => {
    const loadReceipt = async () => {
       try {
        setLoading(true);
        const res = await postData(
          `${API_URL}/${ENDPOINTS.SYS}/reportCustom/fetch-bus-fee-ref-no-info`,
         {
            fee_id,
            ref_no
         }
        );

        const data = res.data;
        console.log("data of invoice:", data);

        if (Array.isArray(data) && data.length > 0) {
          setTranDate(data[0]["Trandate"]);

          setRows(
            data.map((r) => ({
              checkId: r["check"],
              studentId: r["ID"],
              name: r["Magaca Ardayga"],
              school: r["Dugsiga"],
              class: r["Fasalka"],
              month: r["Bisha"],
              amount: Number(r["Lacagta"]),
              checked: true,
            }))
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadReceipt();
  }, [ref_no, token]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    const [, index, field] = name.split(".");

    setRows((prev) =>
      prev.map((r, i) =>
        i === Number(index)
          ? {
              ...r,
              [field]: type === "checkbox" ? checked : Number(value),
            }
          : r
      )
    );
  };

  const total = useMemo(
    () =>
      rows
        .filter((r) => r.checked)
        .reduce((sum, r) => sum + r.amount, 0),
    [rows]
  );


  const selectedRows = rows.filter((r) => r.checked);

  const handleEdit = async (e) => {
  e.preventDefault();

  try {
    const rowsToUpdate = rows.filter(r => r.checked);

    if (rowsToUpdate.length === 0) {
      notification.error({ message: "Select at least one row to update" });
      return;
    }

    if (!tranDate) {
      notification.error({ message: "Tran Date is required" });
      return;
    }

    // Ask for description once
    const description = prompt("Please enter a description for updating:");
    if (!description) {
      alert("Update canceled. Description is required.");
      return;
    }

    // Collect messages for a single toast
    const messages = [];
    let hasError = false;

    for (const r of rowsToUpdate) {
      // Update amount
      const dataAmount = {
        table: "student_bus_receipt",
        id: r.checkId,
        column: "amount",
        value: Number(r.amount),
        user_id: userId,
        description,
      };

      try {
        const resAmount = await axios.put(
          `${API_URL}/${ENDPOINTS.SYS}/updatecolumn`,
          dataAmount,
          { headers: { Authorization: token ? `Bearer ${token}` : "" } }
        );

        if (resAmount.data.success === 0) {
          hasError = true;
          messages.push(`ID ${r.checkId}: ${resAmount.data.message}`);
          continue; // skip tran_date if amount fails
        }

        // Update tran_date
        const dataDate = {
          table: "student_bus_receipt",
          id: r.checkId,
          column: "date",
          value: tranDate,
          user_id: userId,
          description,
        };

        const resDate = await axios.put(
          `${API_URL}/${ENDPOINTS.SYS}/updatecolumn`,
          dataDate,
          { headers: { Authorization: token ? `Bearer ${token}` : "" } }
        );

        if (resDate.data.success === 0) {
          hasError = true;
          messages.push(`ID ${r.checkId}: ${resDate.data.message}`);
        } else {
          messages.push(`ID ${r.checkId}: Updated successfully`);
        }
      } catch (err) {
        hasError = true;
        messages.push(`ID ${r.checkId}: ${err.response?.data?.message || err.message}`);
      }
    }

    // Show ONE combined toast
    if (hasError) {
      notification.error({
        message: "Some updates failed",
        description: messages.join("\n"),
        duration: 6,
      });
    } else {
      notification.success({
        message: `All ${rowsToUpdate.length} receipt(s) updated successfully`,
        description: messages.join("\n"),
        duration: 4,
      });
    }
  } catch (err) {
    notification.error({ message: err.message });
  }
};




   


const selectedIds = rows.filter(r => r.checked).map(r => r.checkId);

const handleCancel = () => {
  if (!selectedIds.length) {
    notification.error({ message: "Select at least one row" });
    return;
  }
  setCancelModalVisible(true);
};

  
  const handleRefund = async () => {
  const rowsToUpdate = rows.filter(r => r.checked);
  if (rowsToUpdate.length === 0) {
    notification.info({
      message: "No receipts selected",
      description: "Please select at least one receipt to refund.",
    });
    return;
  }

  const description = prompt("Please enter a description for refund:");
  if (!description) {
    alert("Refund canceled. Description is required.");
    return;
  }

  const messages = [];
  
  // Use Promise.allSettled for parallel updates
  const results = await Promise.allSettled(
    rowsToUpdate.map(r =>
      axios.put(
        `${API_URL}/${ENDPOINTS.SYS}/updatecolumn`,
        {
          table: "student_bus_receipt",
          id: r.checkId,
          column: "status",
          value: '0',
          user_id: userId,
          description,
        },
        { headers: { Authorization: token ? `Bearer ${token}` : "" } }
      )
    )
  );

  let successCount = 0;

  results.forEach((res, index) => {
    const r = rowsToUpdate[index];
    if (res.status === "fulfilled" && res.value.data.success !== 0) {
      successCount += 1;
      messages.push(`ID ${r.checkId}: refunded successfully`);
    } else {
      const msg =
        res.status === "rejected"
          ? res.reason.response?.data?.message || res.reason.message
          : res.value.data.message;
      messages.push(`ID ${r.checkId}: ${msg}`);
    }
  });

 
  if (successCount < rowsToUpdate.length) {
    notification.error({
      message: "Some refunds failed",
      description: messages.join("\n"),
      duration: 6,
    });
  } else {
    notification.success({
      message: `All ${successCount} receipt(s) Refunded successfully`,
      description: messages.join("\n"),
      duration: 4,
    });
  }
  const full_route=`/student-invoice/student-bus-refund/${ref_no}`;
    window.open(full_route, "_blank");
};


  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="container-fluid mt-3">
      {/* TOP */}
      <div className="row mb-3 d-flex justify-content-between">
        <div className="col-md-3">
          <label className="fw-semibold">Invoice</label>
          <input className="form-control" value={invoice} disabled />
        </div>

       <div className="col-md-3 text-end">
          <label className="fw-semibold">Tran Date</label>
          <input
            type="date"
            className="form-control"
            value={tranDate}
            onChange={(e) => setTranDate(e.target.value)}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>Check</th>
              <th>ID</th>
              <th>Magaca Ardayga</th>
              <th>Dugsiga</th>
              <th>Fasalka</th>
              <th>Bisha</th>
              <th>Lacagta</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, i) => (
              <tr key={r.checkId}>
                <td>
                  <input
                    type="checkbox"
                    checked={r.checked}
                    name={`row.${i}.checked`}
                    onChange={handleChange}
                  />{" "}
                  {r.checkId}
                </td>
                <td>{r.studentId}</td>
                <td>{r.name}</td>
                <td>{r.school}</td>
                <td>{r.class}</td>
                <td>
                  <input className="form-control" value={r.month} disabled />
                </td>
                <td>
                  <input
                    className="form-control text-end"
                    name={`row.${i}.amount`}
                    value={r.amount}
                    onChange={handleChange}
                    disabled={!r.checked}
                  />
                </td>
              </tr>
            ))}

            <tr>
              <td colSpan="6" className="text-end fw-semibold">
                Wadarta Guud
              </td>
              <td className="fw-semibold">${total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <CancelReceiptModal
  ids={selectedIds}
  token={token}
  table='student_bus_receipt'
  visible={cancelModalVisible}
  onClose={() => setCancelModalVisible(false)}
  onSuccess={() => {
    window.location.reload();
  }}
/>

      {/* REASON */}
      {/* <div className="mt-3">
        <label className="fw-semibold">Sababta</label>
        <textarea
          className="form-control"
          rows="3"
          placeholder="Fadlan qor sababta"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </div> */}

      {/* ACTION BUTTONS */}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <button className="btn btn-success px-5" onClick={handleEdit}>
          Edit
        </button>
        <button className="btn btn-secondary px-5" onClick={handleCancel}>
          Cancel
        </button>
        <button className="btn btn-warning px-5" onClick={handleRefund}>
          Refund
        </button>
      </div>
      

    </div>
  );
}
